// extracted by mini-css-extract-plugin
export default {"link":"basket-link--13291","icon":"basket-icon--af88c","link__tn":"basket-link__tn--e1e2c"};